import pfwOverlayController from './pfwOverlay.controller';
import pfwOverlayView from './pfwOverlay.view.html';
import './pfwOverlay.scss';

const pfwOverlayComponent = {

  template: pfwOverlayView,
  controller: pfwOverlayController,
  controllerAs: 'vm'

};

export default pfwOverlayComponent;



// WEBPACK FOOTER //
// ./src/components/pfwOverlay/pfwOverlay.component.js